<template>
  <div class="card__flex card card-box mb-3">
    <div class="card-header pr-2">
      <div class="card-header--title">
        <h4 class="text-danger font-weight-bold">{{ title }}</h4>
      </div>
      <div class="card-header--actions">
        <slot name="header-actions"></slot>
      </div>
    </div>

    <div class="card-body p-0">
      <base-table
        ref="table"
        :provider="fetch"
        :fields="fields"
        :is-busy.sync="isFetching"
        :current-page.sync="currentPage"
        :number-of-pages="numberOfPages"
        :per-page="10"
      >
        <template #cell(actions)="{ item }">
          <div class="text-right">
            <b-button size="sm" @click="seeDetail(item)" class="mr-2"
              >ดูรายละเอียด</b-button
            >
          </div>
        </template>

        <template #cell(refresh)="{ item }">
          <div class="text-center">
            <b-button
              size="sm"
              variant="primary"
              @click="onCreateTransaction(item)"
              >พิมพ์</b-button
            >
            <select-type-create-transaction
              :item="item"
            ></select-type-create-transaction>
            <!-- <generate-pdf
              ref="pdf"
              :item="item"
              :format="format"
            ></generate-pdf> -->
          </div>
        </template>
      </base-table>
    </div>
  </div>
</template>

<script>
import formatDateMixin from "../../mixins/formatDateMixin";
import BaseTable from "./Base";
import { Auth, MRank, Transection } from "../../models";
// import GeneratePdf from "../report/GeneratePdf";
// import { generateTemplate } from "../../helpers/template-pdf-transaction";
import SelectTypeCreateTransaction from "../modal/SelectTypeCreateTransaction";
export default {
  mixins: [formatDateMixin],
  props: {
    title: String,
    fields: Array,
    params: Object,
    actionButtonText: {
      type: String,
      default: "ดูรายละเอียด/พิมพ์",
    },
  },

  components: {
    BaseTable,
    // GeneratePdf,
    SelectTypeCreateTransaction,
  },

  data() {
    return {
      isFetching: false,
      currentPage: parseInt(this.$route.query.page) || 1,
      numberOfPages: 1,
      format: "",
    };
  },

  computed: {
    authUser() {
      return Auth.user();
    },
  },

  watch: {
    params: {
      deep: true,
      handler: "onParamsChanged",
    },
  },

  methods: {
    onParamsChanged() {
      this.currentPage = 1;
      this.numberOfPages = 1;

      this.refresh();
    },

    async fetch(ctx) {
      let data = [],
        additionalParams = {},
        numberOfPages = 1;

      if (this.params && this.params.keyword) {
        this.$set(additionalParams, "keyword", this.params.keyword);
      }

      this.isFetching = true;

      try {
        const params = {};

        if (!ctx.downloadAll) {
          this.$set(params, "limit", ctx.perPage);
          this.$set(params, "offset", (ctx.currentPage - 1) * ctx.perPage);
        }

        // if (!this.authUser.isAdminType) {
        //   this.$set(params, "userProfileId", this.authUser.id);
        // }

        this.$set(params, "userProfileId", this.authUser.id);

        MRank.api().findAll();

        const promise = await Transection.api().findAll(
          {
            ...params,
            ...additionalParams,
          },
          { save: false }
        );

        let { data: responseData = [], number_of_pages = 1 } =
          promise.response.data;

        data = responseData.map((record) => {
          let user_name = "",
            user_id_governmen = "";

          let yearTerm = record.fiscal_year || "";

          if (record.term) {
            yearTerm += `/${record.term}`;
          }

          let classRoom = "";

          if (record.m_class) {
            classRoom += record.m_class.m_class_name;

            const roomNumber = parseInt(record.room);

            if (!isNaN(roomNumber)) {
              classRoom += `/${roomNumber}`;
            }
          }

          if (record.teaching_dares) {
            const firstTeachingDare = record.teaching_dares[0];

            if (firstTeachingDare && firstTeachingDare.user_profile) {
              const firstUserProfile = firstTeachingDare.user_profile;

              const userRank = MRank.find(firstUserProfile.mRankId);

              user_name = `${firstUserProfile.first_name} ${firstUserProfile.last_name}`;
              user_id_governmen = firstUserProfile.id_governmen;

              if (userRank) {
                user_name = `${userRank.m_rank_name} ${user_name}`;
              }
            }
          }

          return {
            ...record,
            // plan_student: record.plan_student || 0,
            // actual_student: record.actual_student || 0,
            // teaching_plan_count: record.teaching_plan_count || 0,
            // room: record.room || "-",
            // fiscal_year: record.fiscal_year || "-",
            // school: record.m_school ? record.m_school.m_school_name : null,
            // station: record.m_station
            //   ? record.m_station.m_station_name
            //   : null,
            // amphur: record.m_school.m_amphur
            //   ? record.m_school.m_amphur.m_amphur_name
            //   : null,
            // province: record.m_school.m_province
            //   ? record.m_school.m_province.m_province_name
            //   : null,
            updated_at: record.updatedAt
              ? this.$_formatDateMixin_formatShort(record.updatedAt)
              : "-",
            created_at: record.createdAt
              ? this.$_formatDateMixin_formatShort(record.createdAt)
              : "-",
            yearTerm,
            classRoom,
            user_name,
            user_id_governmen,
            total_time: record.total_time ? parseInt(record.total_time) : 0,
            total_money: record.total_money ? parseInt(record.total_money) : 0,
          };
        });

        numberOfPages = number_of_pages;
      } catch (error) {
        console.log(error);
        this.$toast.error(
          "ไม่สามารถดึงข้อมูลแผนการสอนได้ กรุณาลองใหม่อีกครั้ง"
        );
      } finally {
        this.isFetching = false;
      }

      if (!ctx.downloadAll) {
        this.numberOfPages = numberOfPages;
      }

      return data;
    },

    seeDetail(item) {
      // เปิด modal ดูรายละเอียด
      this.$emit("seeDetail", item);
    },

    onCreateTransaction(item) {
      this.$bvModal.show(`select-type-create-transaction-modal_${item.id}`);
    },

    // async printTransaction(item) {
    //   // สั่ง print รายละเอียด
    //   this.format = await generateTemplate(this.authUser, item);
    //   if (this.$refs.pdf) {
    //     const { $refs } = this.$refs.pdf;
    //     $refs.html2Pdf.generatePdf();
    //   }
    // },

    refresh() {
      this.$refs.table.refresh();
    },
  },
};
</script>
